import { useMemo } from 'react'

import { useReselector } from '@/utils/sharedHooks'

import { selectAnswers } from '../compliance.selectors'
import { complianceVerdict } from '../lib/qualification'

/** Reported rather than omitted while the deciding questions are unanswered, so a
 *  funnel split on this property accounts for everyone who reached the surface. */
const UNDECIDED = 'undecided'

/**
 * The qualification treatment as an event property, for every compliance surface that
 * carries one. One definition so the report, its calls to action and the plans page
 * cannot report different verdicts for the same practice within a single session.
 */
export const useComplianceVerdict = (): string => {
  const answers = useReselector(selectAnswers)

  return useMemo(
    () => complianceVerdict(answers)?.treatment ?? UNDECIDED,
    [answers]
  )
}
